import { xyCumulativeDistributionStatistics } from 'ml-spectra-processing';

export function getStats(spectrum) {
  let stats = {};
  if (spectrum.variables.x && spectrum.variables.y) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.y.data,
    };
    stats.weight = xyCumulativeDistributionStatistics(data);
  }

  if (spectrum.variables.x && spectrum.variables.n) {
    let data = {
      x: spectrum.variables.x.data,
      y: spectrum.variables.n.data,
    };
    stats.number = xyCumulativeDistributionStatistics(data);
  }
  return stats;
}
